import styled from "styled-components";

export const ModalContainer = styled.div`
    background: ${(props) => props.theme.colors.neutral[100]};
    color: ${(props) => props.theme.colors.neutral[800]};
    height: fit-content;
    width: 50vw;

    border-radius: 0.2rem;

    resize: both;

    display: flex;
    flex-flow: column;

    & > *:first-child {
        flex: 0 0 4rem;
    }

    & > *:nth-child(2) {
        flex: 1;
    }

    @media (max-width: 768px) {
        height: 70vh;
        width: 95vw;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    padding: 5%;
`;

export const FormContainer = styled.form`
    display: contents;
    & > * {
        &:first-child {
            flex: 1;
            z-index: 2;
        }
        &:nth-child(2) {
            min-width: 2.3rem;
            flex: 0 0 2.3rem;
            margin-top: 1rem;
        }
    }
`;
